<template>
  <div class="mb-5">
    <div v-if="listArquivos.length == 0" class="p-5">
      <h6>Não há fotos ou documentos a serem exibidos.</h6>
    </div>

    <div v-else class="vx-row">
      <div
        class="vx-col lg:w-1/2 xl:w-1/4 w-full mt-5"
        v-for="arquivo in listArquivos"
        :key="arquivo.idEventoFoto"
      >
        <vs-card :class="{ remove: arquivo.deletar }">
          <div class="flex justify-between">
            <div class="p-2 break-all">
              <a :href="arquivo.url" target="_blank">
                {{
                  arquivo.url.substr(
                    arquivo.url.lastIndexOf('/') + valorSubstringLink,
                  )
                }}
              </a>
              <p>
                {{ formatDateHour(arquivo.updatedAt) }}
              </p>
              <p>
                {{ arquivo.nomeUsuario }}
              </p>
            </div>

            <div class="flex">
              <vs-button
                v-if="arquivo.deletar"
                v-tooltip="'Deletar arquivo'"
                type="gradient"
                color="success"
                icon="undo"
                size="small"
                @click="undoArquivoToDelete(arquivo)"
              ></vs-button>

              <vs-button
                v-else
                v-tooltip="'Deletar arquivo'"
                type="gradient"
                color="danger"
                icon="close"
                size="small"
                @click="selectArquivoToDelete(arquivo)"
              ></vs-button>
            </div>
          </div>

          <div>
            <a
              v-if="isPdf(arquivo.nome)"
              class="flex justify-center"
              :href="arquivo.nome"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="w-1/2"
                src="../../../src/assets/images/elements/PDF_file_icon2.png"
              />
            </a>

            <img
              v-else
              @click="openModalDetalhes(arquivo)"
              class="w-full cursor-pointer"
              :src="arquivo.nome"
            />
          </div>
        </vs-card>
      </div>
    </div>

    <div v-if="listArquivos.length >= 40">
      <vs-alert title="Atenção" active="true" color="danger">
        Você chegou ao limite máximo de 40 fotos. Favor remover fotos atuais
        para poder acrescentar novas fotos.
      </vs-alert>
    </div>

    <div class="pt-5 pl-5">
      <span class="colorBlue"
        >Limite de fotos: {{ listArquivos.length }} / 40</span
      >
    </div>
    <div
      class="flex justify-end gap-3 items-center mt-2 lg:flex-row flex-col mw-"
    >
      <div class="flex gap-3 lg:flex-row flex-col">
        <vs-button
          color="danger"
          :disabled="!listArquivosToDelete.length"
          @click="deleteRegistroArquivos()"
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="Trash2Icon" />
            <span
              >Deletar: {{ listArquivosToDelete.length }} arquivos selecionados
            </span>
          </div></vs-button
        >
      </div>
      <div>
        <vs-button
          @click.stop.prevent="openModalUpload(idReferente)"
          :disabled="listArquivos.length >= 40"
          class="w-full"
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="UploadIcon" />Escolher arquivos
          </div></vs-button
        >
      </div>
    </div>

    <vs-popup
      title="Fotos e Documentos"
      :active.sync="modalFotoAtivo"
      fullscreen
    >
      <div v-if="itemModalSelecionado">
        <div class="flex justify-center m-5">
          {{
            itemModalSelecionado.legenda
              ? itemModalSelecionado.legenda
              : itemModalSelecionado.nome
          }}
        </div>
        <div class="flex justify-center">
          <img :src="itemModalSelecionado.nome" />
        </div>
      </div>
    </vs-popup>

    <!-- Modal Upload de fotos e documentos -->
    <vs-popup
      style="z-index: 100000"
      :title="this.titleModalUpload"
      :active.sync="modalUploadAtivo"
      :id="`idReferente${idReferente}`"
    >
      <div v-if="!listFilesFromS3.length" class="m-5 mb-10">
        <h5>Não há arquivos selecionados</h5>
      </div>
      <div v-else class="flex flex-wrap">
        <div
          v-for="(arquivo, index) in listFilesFromS3"
          :key="index"
          class="lg:w-1/2 w-full p-2"
        >
          <vs-card>
            <div class="flex justify-between items-center">
              <a
                target="_blank"
                class="text-lg"
                :href="arquivo.url"
                rel="noopener noreferer"
              >
                {{ arquivo.nome }}
              </a>
              <vs-button
                v-tooltip="'Deletar arquivo'"
                type="gradient"
                color="danger"
                icon="close"
                size="small"
                class="mb-2"
                @click="deleteArquivoUpload(index)"
              ></vs-button>
            </div>
          </vs-card>
        </div>
      </div>
      <div
        v-if="listFilesFromS3.length + listArquivos.length >= 40"
        class="mb-3"
      >
        <vs-alert title="Atenção" active="true" color="danger">
          <span v-if="listArquivos.length"
            >Você já possui {{ listArquivos.length }} fotos salvas.</span
          >
          Subindo essas fotos, você chegará ao limite total máximo de 40 fotos.
          Favor remover fotos atuais para poder acrescentar novas fotos.
        </vs-alert>
      </div>

      <!-- Footer -->
      <div class="flex justify-end gap-5">
        <vs-button
          @click="openEscolhaArquivoUpload(idReferente)"
          :disabled="listFilesFromS3.length + listArquivos.length >= 40"
          color="warning"
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="PlusIcon" />Escolher arquivos
          </div></vs-button
        >
        <input
          :id="`fileUpload${idReferente}${idTerceiro}`"
          type="file"
          accept="image/*,.pdf"
          @change="selectArquivoUpload"
          name="files"
          multiple
          enctype="multipart/form-data"
          hidden
        />
        <vs-button
          @click="uploadArquivosSelecionados()"
          :disabled="
            listFilesFromS3.length + listArquivos.length > 40 ||
            !listFilesFromS3.length
          "
        >
          <div class="flex items-center gap-2">
            <feather-icon icon="UploadIcon" />Upload:
            {{ listFilesFromS3.length }} arquivos selecionados
          </div></vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import moment from 'moment';

import service from '../../../src/services/index';
import notify from '../../../src/utils/notify';
import functions from '../../utils/functions';

export default {
  props: {
    formData: Object,
    arquivos: Array,
    idReferente: Number,
    title: {
      type: String,
      default: 'Cadastrar Fotos e Documentos',
    },
  },
  data() {
    return {
      showComponent: true,
      idUsuario: null,
      modalFotoAtivo: false,
      modalUploadAtivo: false,
      titleModalUpload: null,
      itemModalSelecionado: null,
      listFilesFromS3: [],
      listArquivosToDelete: [],
      listArquivos: [],
      files: [],
      idTerceiro: null,
      idRelacionamento: null,
      valorSubstringLink: 15,
      formCadastro: {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculo: null,
        idVeiculos: null,
        url: null,
        uploadedBy: null,
        ip: null,
        observacao: null,
      },
    };
  },
  watch: {
    formData(value) {
      this.idEvento = value.idEvento;
      this.idTerceiro = value.idTerceiro || null;
    },
    arquivos(value) {
      this.listArquivos = value;
    },
    updatedExistPhotos() {
      this.$emit('dataChanged', this.urlArquivoLocal);
    },
  },
  methods: {
    callOnSubmit(data) {
      (this.formCadastro = data),
        (this.idRelacionamento = data.idRelacionamento);
    },
    openModalDetalhes(arquivo) {
      this.modalFotoAtivo = true;
      this.itemModalSelecionado = arquivo;
    },
    openModalUpload() {
      this.modalUploadAtivo = true;
      this.titleModalUpload = 'Upload de Fotos e Documentos';
    },
    openEscolhaArquivoUpload() {
      document
        .getElementById(`fileUpload${this.idReferente}${this.idTerceiro}`)
        .click();
    },
    selectArquivoUpload(event) {
      const fileList = event.target.files;

      if (!fileList.length) {
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        this.listFilesFromS3.push({
          legenda: this.getNomeArquivoSemExtensao(file.name),
          url: URL.createObjectURL(file),
          nome: file.name,
        });
        this.files.push(file);
      }
    },
    getNomeArquivoSemExtensao(nomeArquivo) {
      const ultimoPontoIndex = nomeArquivo.lastIndexOf('.');

      if (ultimoPontoIndex !== -1) {
        return nomeArquivo.substring(0, ultimoPontoIndex);
      }

      return nomeArquivo;
    },
    isPdf(urlArquivo) {
      if (!urlArquivo) return false;

      const ext = urlArquivo.split('.').pop();

      return ext === 'pdf';
    },
    deleteArquivoUpload(index) {
      this.listFilesFromS3.splice(index, 1);

      const deletedFile = this.listFilesFromS3[index];
      const fileIndex = this.files.findIndex(
        (file) => file.name === deletedFile.nome,
      );

      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }
    },
    selectArquivoToDelete(arquivoSelecionado) {
      arquivoSelecionado.deletar = true;
      this.listArquivosToDelete.push(arquivoSelecionado);
    },
    undoArquivoToDelete(arquivoSelecionado) {
      delete arquivoSelecionado.deletar;

      const index = this.listArquivosToDelete.findIndex(
        (item) => item.idArquivo === arquivoSelecionado.idArquivo,
      );

      if (index !== -1) {
        this.listArquivosToDelete.splice(index, 1);
      }
    },
    async uploadFileToS3(files) {
      try {
        const listFiles = files.map((file) => ({
          idRelacionamento: this.idRelacionamento,
          idAssociado: this.formCadastro.idAssociado,
          idVeiculo: this.formCadastro.idVeiculo,
          idVeiculos: this.formCadastro.idVeiculos,
          uploadedBy: this.formCadastro.idUsuario,
          ip: this.formCadastro.ip,
          url: file,
        }));

        const result = await service.post(
          'Relacionamento',
          'inserir-anexos-relacionamento',
          listFiles,
        );
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Fotos registrada(s) com sucesso',
          color: 'success',
        });
        // POG
        setTimeout(() => {
          this.listArquivos = result.data;
        }, 500);
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || 'Erro ao processar o pedido',
          color: 'danger',
        });
        return Promise.reject(error);
      }
    },

    async uploadArquivosSelecionados() {
      try {
        this.$vs.loading();

        const formDataSend = new FormData();

        this.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idRelacionamento,
          formDataSend,
        );

        await this.uploadFileToS3(uploadedFiles);

        this.modalUploadAtivo = false;
        this.listFilesFromS3 = [];
        this.files = [];
        this.listArquivos = [];
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível subir os arquivos');
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        this.idUsuario = decoded.id_usuario;
      }
    },
    resetForm() {
      this.form = {
        solicitante: null,
        idStatus: null,
        descricaoAtendimento: null,
      };
    },
    async deleteRegistroArquivos() {
      try {
        this.$vs.loading();

        const payload = {
          ids: [],
        };

        this.listArquivosToDelete.forEach((file) => {
          payload.ids.push(file.idRelacionamentoAnexo);
        });

        await service.post(
          'Relacionamento',
          'remover-anexos-relacionamento',
          payload,
        );
        const listaAtualizada = this.listArquivos.filter(
          (arquivo) => !this.listArquivosToDelete.includes(arquivo),
        );
        this.listArquivos = listaAtualizada;
        this.listArquivosToDelete = [];
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Anexos removido(s) com sucesso',
          color: 'success',
        });
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível deletar os arquivos');
        console.log(error);
      } finally {
        this.listArquivosToDelete = [];
        this.$vs.loading.close();
      }
    },
    formatDateHour(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('DD/MM/YYYY');
    },
  },
  async mounted() {
    this.getDecoded();
    this.formCadastro.ip = await functions.getIP();
  },
  updatedExistPhotos() {
    this.$emit('dataChanged', this.urlArquivoLocal);
  },
};
</script>

<style>
.colorBlue {
  color: #00bfed;
}

.remove {
  background-color: rgb(252 165 165);
  color: black;
}
</style>
